import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'

// Every other layout letterboxes the app into a phone frame on desktop
// (md:px-[35%] + slate gutters). The admin dashboard is the first truly
// responsive page, so this layout hands its routes the full viewport width
// with a capped, centered container instead.
const AdminDashboardLayout = ({ helmet }: { helmet: string }) => {
    const { pathname } = useLocation()
    useHelmet(helmet)

    return (
        <div className=" min-h-screen bg-canvas">
            <motion.div
                key={pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
                className=" mx-auto w-full max-w-[1120px] px-4 md:px-8"
            >
                <Outlet />
            </motion.div>
        </div>
    )
}

export default AdminDashboardLayout
